import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";
import {WebConferencesSlides} from "@api/models/WebСonferencesSlides";
import {CreateSlidesParameters} from "@api/models/interfaces/web-conference/CreateSlidesParameters";

export class WebConferencesSlidesRepository implements Repository{
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    create(schemaId: string, objectId: string, body: CreateSlidesParameters) {
        return this.client.post<WebConferencesSlides>(`/webConferences/${schemaId}/${objectId}/slides`, body)
            .then(({data}) => new WebConferencesSlides(data));
    }

    list(schemaId: string, objectId: string) {
        return this.client.get<WebConferencesSlides[]>(`/webConferences/${schemaId}/${objectId}/slides`)
            .then(({data}) => {
                return data.map((item) => new WebConferencesSlides(item));
            });
    }

    get(schemaId: string, objectId: string, id: string) {
        return this.client.get<WebConferencesSlides>(`/webConferences/${schemaId}/${objectId}/slides/${id}`)
            .then(({data}) => {
                return new WebConferencesSlides(data);
            });
    }

    delete(schemaId: string, objectId: string, id: string) {
        return this.client.delete(`/webConferences/${schemaId}/${objectId}/slides/${id}`);
    }

    convert(schemaId: string, objectId: string, id: string) {
        return this.client.post(`/webConferences/${schemaId}/${objectId}/slides/${id}/convert`);
    }
}
